/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains a hook that proxies a hook from 
 * online-patient-management-reducers making less types required to use the hook.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';







import Collapse from '@material-ui/core/Collapse';

import { useField, useFormState } from 'react-final-form';


/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */



import * as Dtos from '../../../../api/Neon.Dtos';



import { pascalToCamelCase } from '../../OpmsInput';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FormGridRowErrorContext from '../../../../context/FormGridErrorContext';
import OpmsErrorSummary from '../../OpmsErrorSummary';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */
interface IOpmsFormGridRowErrors {
    fields?: string[];
    columnCount: number;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles<Theme>(theme => ({
    cell: {
        padding: `${theme.spacing(0)} !important`,
        borderBottom: `none !important`
    }
}));


/*
 * ---------------------------------------------------------------------------------
 * components
 * ---------------------------------------------------------------------------------
 */

const OpmsFormGridRowErrors: React.FunctionComponent<IOpmsFormGridRowErrors> = ({
    fields,
    columnCount
}: IOpmsFormGridRowErrors) => {
    const classes = useStyles();

    const { errors: formErrors, touched: touchedFields } = useFormState({ subscription: { errors: true, touched: true } });

    const { input: { value: formId } } = useField('id', { subscription: { value: true } });

    const rowErrorState = React.useContext(FormGridRowErrorContext);

    const typedErrors: Dtos.IValidationError[] | undefined = React.useMemo(() => {
        return fields?.filter(f => {

            const splitFieldConst = f.split('.');

            const fieldName = splitFieldConst.map(s => pascalToCamelCase(s)).join('.');

            return !!formErrors && !!formErrors[f] && ((touchedFields && touchedFields[fieldName]) || formId)
        }).map(f => {
            return formErrors && formErrors[f!]
        }).reduce((a, b) => a.concat(b), [])
    }, [fields, touchedFields, formErrors, formId]);

    return (
        <TableRow>
            <TableCell colSpan={columnCount} className={classes.cell}>
                <Collapse in={rowErrorState?.expanded}>
                    <OpmsErrorSummary
                        validationErrors={typedErrors}
                    />
                </Collapse>
            </TableCell>
        </TableRow>
    )
}

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default OpmsFormGridRowErrors;
